import React from "react";

export default function HTMLViewer(props) {
  return (
    <div
      class="q-container"
      style={props.style || {}}
      dangerouslySetInnerHTML={{ __html: props.content }}
    />
  );
}
